module.exports = __webpack_public_path__ + "media/boo.3e6c8808.mp3";